"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.changePhoneNumber = exports.changeMemberAvatar = exports.handleUpdateMemberInfo = exports.changeMemberPassword = exports.MEMBER_INFO_EXPANDS = void 0;
const fetchClient_1 = require("../../../utils/misc/fetchClient");
exports.MEMBER_INFO_EXPANDS = [
    "postCount",
    "bookmarkCount",
    "commentCount",
    "limitAccountReport",
    "viewsCount",
    "commentCount",
    "is_reported",
    "rating",
    "followingsCount",
    "followersCount",
    "is_followed",
    "views",
    "followingsPostsCount",
    "responseTime",
    "followersCountText",
    "viewsCountText",
];
const changeMemberPassword = (body) => __awaiter(void 0, void 0, void 0, function* () {
    let url = "slr/change-password";
    return yield (0, fetchClient_1.fetchAtClientSide)({ url, body, method: "POST" });
});
exports.changeMemberPassword = changeMemberPassword;
const handleUpdateMemberInfo = (body) => __awaiter(void 0, void 0, void 0, function* () {
    let url = "members";
    return yield (0, fetchClient_1.fetchAtClientSide)({ url, body, method: "PUT" });
});
exports.handleUpdateMemberInfo = handleUpdateMemberInfo;
const changeMemberAvatar = (imageBinary) => __awaiter(void 0, void 0, void 0, function* () {
    const url = "members/avatar";
    return yield (0, fetchClient_1.fetchAtClientSide)({ url, body: imageBinary, method: "POST", type: "FILE" });
});
exports.changeMemberAvatar = changeMemberAvatar;
const changePhoneNumber = (body) => __awaiter(void 0, void 0, void 0, function* () {
    const url = "slr/update-phone";
    return yield (0, fetchClient_1.fetchAtClientSide)({ url, body, method: "POST" });
});
exports.changePhoneNumber = changePhoneNumber;
